import React, { useEffect } from 'react';
import './style.css';
import { Button, TextField } from '@mui/material';
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section contactPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4 text-center">Contact Us</h1>

                <div className="row mt-5">
                    <div className="col-md-4">
                        <div className="contactCard text-center p-4">
                            <LocationOnOutlinedIcon />
                            <h4>Address</h4>
                            <p>First Floor Sh 52 Madhubani Benipatti Road Arer near SBI Bank Madhubani Bihar 847223</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="contactCard text-center p-4">
                            <HeadphonesOutlinedIcon />
                            <h4>Call Us</h4>
                            <p>+91 9942265212</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="contactCard text-center p-4">
                            <EmailOutlinedIcon />
                            <h4>Email</h4>
                            <p>paymondtechnologies@gmail.com</p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5 justify-content-center">
                    <div className="col-md-8">
                        <div className="card p-5 contactForm">
                            <h2 className="hd">Send Us a Message</h2>
                            <form className="mt-4">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <TextField label="Your Name" variant="outlined" className="w-100" />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <TextField label="Your Email" variant="outlined" className="w-100" />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <TextField label="Subject" variant="outlined" className="w-100" />
                                </div>
                                <div className="mb-3">
                                    <TextField label="Message" variant="outlined" className="w-100" multiline rows={4} />
                                </div>
                                <Button className="btn-g btn-lg w-100">Send Message</Button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
